import React from 'react'
import { Table } from 'react-bootstrap'
import { flexRender } from '@tanstack/react-table'
import { ReactComponent as UpArrow } from '../../assets/images/reacttableicons/upArrow.svg'
import { ReactComponent as DownArrow } from '../../assets/images/down-arrow.svg'
import SpinnerLoader from '../SpinnerLoader'
const ReactTable = ({ tableInstance, isLoading }) => {
    return (
        <Table
            bordered
            responsive
            className="customtable scrollbar"
            style={{
                width: '100%',
                overflow: 'auto'
            }}
        >
            <thead>
                {tableInstance.getHeaderGroups().map((headerGroup, i) => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th
                                key={header.id}
                                align="center"
                                colSpan={header.colSpan}
                            >
                                {header.isPlaceholder ? null : (
                                    <div
                                        className={`thead ${
                                            header?.id === 'actions'
                                                ? 'action-data'
                                                :header?.id==="companyAddress"?"cadd": ''
                                        }`}
                                        onClick={header.column.getToggleSortingHandler()}
                                    >
                                        {flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                        &nbsp;&nbsp;
                                        {{
                                            asc: (
                                                <UpArrow
                                                    style={{
                                                        // backgroundColor:"rgb(199 215 229)",
                                                        height: '10px',
                                                        width: '10px'
                                                        // border:"2px solid black"
                                                    }}
                                                />
                                            ),
                                            desc: (
                                                <UpArrow
                                                    style={{
                                                        transform:
                                                            'rotate(180deg)',
                                                        // backgroundColor:"rgb(199 215 229)",
                                                        height: '10px',
                                                        width: '10px'
                                                        // border:"2px solid black"
                                                    }}
                                                />
                                            )
                                        }[header.column.getIsSorted()] ?? null}
                                    </div>
                                )}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            {/* {isLoading ? <SpinnerLoader/> : <> */}
            <tbody>
                {tableInstance.getRowModel().rows.map((row, i) => {
                    return (
                        <tr key={row.id}>
                            {row.getVisibleCells().map((cell, i) => {
                                return (
                                    <td
                                        className={`tdata ${
                                            cell?.column?.id === 'actions'
                                                ? 'action-data'
                                                :cell?.column?.id==="companyAddress"?"cadd" :''
                                        }`}
                                        key={cell.id}
                                        align="center"
                                    >
                                        {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                        )}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
            {/* </>} */}
        </Table>
    )
}

export default ReactTable
